'use client'

import React from 'react'

export function ShareButton({
  canonicalUrl,
  title,
  excerpt,
  label,
}: {
  canonicalUrl?: string
  title: string
  excerpt?: string | null
  label: string
}) {
  const handleShare = async () => {
    const href = canonicalUrl || (typeof window !== 'undefined' ? window.location.href : '')
    const url = href ?? ''
    if (!url) return
    if (navigator.share) {
      try {
        await navigator.share({ title, text: excerpt || '', url })
      } catch (_) {
        try {
          await navigator.clipboard.writeText(url)
        } catch {}
      }
    } else {
      try {
        await navigator.clipboard.writeText(url)
      } catch {}
    }
  }

  return (
    <button
      onClick={handleShare}
      className="flex-1 bg-gray-800 hover:bg-strandforge-purple text-white font-medium py-2 px-4 rounded transition-colors"
    >
      {label}
    </button>
  )
}
